/**
 * Antd 静态方法提供者
 *
 * 解决 antd v5 "Static function can not consume context" 警告
 * 通过在 <App> 内部捕获 context-aware 实例，供全局使用
 *
 * 用法：
 * 1. 组件代码: import { message, modal, notification } from '@/utils/antdStatic';
 * 2. 非组件代码（如 request.ts）: 同上，实例在首次渲染后可用
 */

import { App } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';

let message: MessageInstance;
let notification: NotificationInstance;
let modal: Omit<ModalStaticFunctions, 'warn'>;

/**
 * 放在 <App> 组件内部，捕获 context-aware 的实例
 * 渲染后 message/modal/notification 即可在任意位置使用
 */
export function AntdStaticProvider() {
  const app = App.useApp();
  message = app.message;
  notification = app.notification;
  modal = app.modal;
  return null;
}

export { message, notification, modal };
